import { render, staticRenderFns } from "./BoNotification.vue?vue&type=template&id=c830477e&"
import script from "./BoNotification.vue?vue&type=script&lang=js&"
export * from "./BoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports